module.exports = __webpack_public_path__ + "static/media/dress-in-shop.b3969398.jpg";